import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function ChangePassword() {
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (form.new_password !== form.confirm) return toast.error("Konfirmasi password tidak cocok");
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: form.current_password, new_password: form.new_password });
      toast.success("Password berhasil diubah");
      setForm({ current_password: "", new_password: "", confirm: "" });
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); } finally { setSaving(false); }
  };

  const inp = "w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white outline-none focus:border-gold text-sm";

  return (
    <div className="max-w-md">
      <h1 className="font-syne font-bold text-3xl text-white mb-1">Ganti Password</h1>
      <p className="text-white/50 mb-8">Perbarui password akun admin Anda.</p>
      <div className="space-y-4">
        <div><label className="text-xs text-white/50 uppercase mb-1.5 block">Password Lama</label><input type="password" value={form.current_password} onChange={(e) => setForm({ ...form, current_password: e.target.value })} className={inp} data-testid="cp-current" /></div>
        <div><label className="text-xs text-white/50 uppercase mb-1.5 block">Password Baru</label><input type="password" value={form.new_password} onChange={(e) => setForm({ ...form, new_password: e.target.value })} className={inp} data-testid="cp-new" /></div>
        <div><label className="text-xs text-white/50 uppercase mb-1.5 block">Konfirmasi Password Baru</label><input type="password" value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} className={inp} data-testid="cp-confirm" /></div>
        <button onClick={save} disabled={saving} className="btn-gold px-8 py-3 rounded-xl disabled:opacity-60" data-testid="cp-submit">{saving ? "Menyimpan…" : "Ubah Password"}</button>
      </div>
    </div>
  );
}
